<template>
  <div class="group-container" :class="{ bolder: dataSteps.length > 1 }">
    <div class="step-container" v-for="step in dataSteps" :key="step.id">
      <i
        class="el-icon-circle-plus-outline mr-5 pointer"
        style="color: #409eff; font-size: 18px"
        v-if="step.id > 0"
        @click="addNewStep(step.id, true)"
      ></i>

      <div
        style="position: relative"
        :class="{ stepbolder: dataSteps.length > 1 }"
      >
        <div>
          <el-popover placement="right-end" width="420" trigger="click">
            <div style="padding: 15px 0">
              <el-form
                size="mini"
                label-width="110px"
                :model="step"
                :disabled="!edit"
                class="flow-form"
              >
                <el-form-item label="步骤名称">
                  <el-input
                    style="width: 220px"
                    v-model="step.name"
                    placeholder="步骤名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="步骤描述">
                  <el-input
                    style="width: 220px"
                    v-model="step.desc"
                    placeholder="步骤描述"
                  ></el-input>
                </el-form-item>
                <el-form-item label="分配规则">
                  <el-select v-model="step.process_category">
                    <el-option
                      label="随机分配：可被分配人员中随机分配一人"
                      :value="0"
                    ></el-option>
                    <el-option
                      label="就近分配：优先分配客户名下正在服务的人员；其次按可被分配人员根据城市、省、区域依次匹配就近分配一人"
                      :value="1"
                    ></el-option>
                    <el-option
                      label="按派工关系分配：优先按工程师与派工员的关联关系分配；若关联关系不存在，则在可被分配人员中随机分配一人"
                      :value="3"
                    ></el-option>
                    <el-option
                      label="销售处理：按客户销售关系（直销销售、电话销售、新品销售）随机分配一人"
                      :value="2"
                    ></el-option>
                    <el-option
                      label="维修点处理：分配给维修点中间商的超级管理员"
                      v-if="isoutflow"
                      :value="10"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="可被分配人员"
                  v-if="[0, 1, 3].includes(step.process_category)"
                >
                  <el-select v-model="step.director_type">
                    <el-option
                      :value="2"
                      key="2"
                      label="按角色分配"
                    ></el-option>
                    <el-option
                      :value="1"
                      key="1"
                      label="按人员分配"
                    ></el-option>
                  </el-select>
                  <template v-if="step.director_type == 2">
                    <MultiRoleSelect
                      class="mt-10"
                      key="111"
                      v-model="step.director_role_ids"
                    ></MultiRoleSelect>
                  </template>
                  <template v-else>
                    <MultiRoleSelect
                      class="mt-10"
                      v-show="edit"
                      v-model="filterRoleId"
                      key="222"
                      :multiple="false"
                    ></MultiRoleSelect>
                    <MultiUserSelect
                      class="mt-10"
                      v-model="step.director_ids"
                      :roleId="filterRoleId"
                      auth-code="171242"
                    >
                    </MultiUserSelect>
                  </template>
                </el-form-item>
                <el-form-item
                  label="自动指派"
                  v-if="[0, 1, 3].includes(step.process_category)"
                >
                  <el-radio-group v-model="step.auto_dispatch">
                    <el-radio :label="0">是</el-radio>
                    <el-radio :label="1">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="未完成时回退到">
                  <el-select v-model="step.return_step">
                    <el-option label="不回退" :value="0"></el-option>
                    <el-option
                      v-for="step in returnStepOptions"
                      :key="step.id"
                      :label="step.name"
                      :value="step.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="小程序显示">
                  <template slot="label"
                    >小程序显示<CustomTip :t="7"></CustomTip
                  ></template>
                  <el-select v-model="step.is_show_in_mini" class="long">
                    <el-option label="是" :value="1" key="1"></el-option>
                    <el-option label="否" :value="2" key="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label="通知人员">
                  <MultiUserSelect
                    v-model="step.notify_user_ids"
                    auth-code="171242"
                  ></MultiUserSelect>
                </el-form-item>
                <el-form-item label="通知角色">
                  <MultiRoleSelect
                    v-model="step.notify_role_ids"
                  ></MultiRoleSelect>
                </el-form-item>
                <el-form-item label="通知销售">
                  <el-radio-group v-model="step.notify_saler">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="评价短信">
                  <el-radio-group v-model="step.send_comment_msg">
                    <el-radio :label="1">发送</el-radio>
                    <el-radio :label="0">不发送</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-divider></el-divider>
                <el-form-item label="等待时间">
                  <el-input
                    placeholder="请输入等待时间"
                    v-model.number="step.wait_time"
                    style="width: 220px"
                  >
                    <template slot="suffix"
                      ><span style="color: #bbc1ca">个工作日</span></template
                    >
                  </el-input>
                </el-form-item>
                <el-form-item label="关联填写项">
                  <el-checkbox-group v-model="step.relative_fileds">
                    <el-checkbox :label="1"
                      >Service Order / Notification</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
              </el-form>
              <div
                style="margin-left: 100px"
                v-permission="Auth.serviceQuestFlowStep"
              >
                <el-button
                  v-if="edit"
                  type="primary"
                  size="mini"
                  plain
                  @click="handleSaveStep(step)"
                  >保存</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  v-else
                  @click="edit = true"
                  >编辑</el-button
                >
                <el-popconfirm
                  title="确认删除该步骤吗？"
                  @confirm="deleteStep(step.id)"
                >
                  <el-button
                    type="danger"
                    size="mini"
                    class="ml-10"
                    slot="reference"
                    plain
                    >删除</el-button
                  >
                </el-popconfirm>
              </div>
            </div>
            <div class="step-name" slot="reference" @click="handleEdit(step)">
              {{ step.name || '点击编辑' }}
            </div>
          </el-popover>
        </div>
      </div>

      <i
        class="el-icon-circle-plus-outline ml-5 pointer"
        style="color: #409eff; font-size: 18px"
        v-if="step.id > 0"
        @click="addNewStep(step.id)"
      ></i>
      <i
        class="el-icon-right ml-10 mr-10"
        v-if="step.children && step.children.length > 0"
      ></i>

      <template v-if="step.children">
        <stepTree
          :steps="step.children"
          :all-steps="allSteps"
          :root="step.id"
          :flowid="flowid"
          :isoutflow="isoutflow"
        >
        </stepTree>
      </template>
    </div>
    <el-button
      type="primary"
      size="mini"
      plain
      v-if="root == 0 && steps.length == 0"
      @click="addNewStep(0)"
      >添加步骤</el-button
    >
  </div>
</template>

<script>
import {
  createServiceQuestFlowStep,
  updateServiceQuestFlowStep,
  deleteServiceQuestFlowStep,
} from '@/service/getData'
import MultiUserSelect from '@/components/select/multi_user_select.vue'
import MultiRoleSelect from '@/components/select/multi_role_select.vue'
import _ from 'lodash'
import store from '@/store/store'

export default {
  components: {
    MultiUserSelect,
    MultiRoleSelect,
  },
  name: 'stepTree',
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    allSteps: {
      type: Array,
      default: () => [],
    },
    root: {
      type: Number,
      default: 0,
    },
    flowid: {
      type: Number,
      default: 0,
    },
    isoutflow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataSteps: [],
      edit: false,
      editid: 0,
      filterRoleId: '',
    }
  },
  watch: {
    steps: function () {
      this.dataSteps = this.steps
    },
    // allSteps: function () {
    //   this.findParent(this.allSteps, this.da)
    //   console.log(1111)
    // },
  },
  computed: {
    returnStepOptions() {
      let result = []
      this.findParent(this.allSteps, this.editid, result)
      return result
    },
  },
  created() {
    this.dataSteps = this.steps
  },
  methods: {
    async addNewStep(fatherid, pre = false) {
      let data = {
        service_quest_flow_id: this.flowid,
        father_id: fatherid,
        is_pre: pre,
        relative_fileds: [],
        name: '',
        wait_time: 1,
      }
      let res = await createServiceQuestFlowStep(data)
      if (res.code == 0) {
        store.commit('setEditStep', res.data)
      }
    },
    handleEdit(step) {
      this.edit = step.name.length == 0
      this.editid = step.id
    },
    async handleSaveStep(step) {
      let res = await updateServiceQuestFlowStep(step)
      if (res.code == 0) {
        store.commit('setEditStep', res.data)
        this.$notify({
          title: '已保存',
          type: 'success',
        })
      }
    },
    async deleteStep(stepid) {
      let res = await deleteServiceQuestFlowStep(stepid)
      if (res.code == 0) {
        store.commit('setEditStep', res.data)
      }
    },
    //data：要遍历的数据， target：查找目标， result用于装查找结果的数组
    findParent(data, targetid, result) {
      for (let item of data) {
        if (item.id === targetid) {
          //将查找到的目标数据加入结果数组中
          //可根据需求unshift(item.id)或unshift(item)
          result.push({ id: -1, name: '当前步骤' })
          return true
        }
        if (item.children && item.children.length > 0) {
          //根据查找到的结果往上找父级节点
          let isFind = this.findParent(item.children, targetid, result)
          if (isFind) {
            result.push({ id: item.id, name: item.name || '未命名步骤' })
            return true
          }
        }
      }
      //走到这说明没找到目标
      return false
    },
  },
}
</script>

<style scoped>
.group-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;
}

/* .group-container.bolder::before {
  content: '';
  position: absolute;
  left: -10px;
  width: 1px;
  height: calc(100% - 32px);
  top: 16px;
  border-left: 1px solid #292b2c;
} */
.step-container {
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 5px;
}

.group-container.bolder .step-container::before {
  content: '';
  position: absolute;
  left: -10px;
  width: 1px;
  height: calc(100% + 1000px);
  top: 16px;
  top: 50%;
  border-left: 1px solid #292b2c;
}

.group-container.bolder .step-container:last-child::before {
  border-color: #fff;
}

.close-btn {
  position: absolute;
  right: 2px;
  top: 2px;
}

.fix-input {
  max-width: 100px;
  position: relative;
}

.stepbolder::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 1px;
  background: #292b2c;
  left: -37px;
  top: 16px;
}

.step-name {
  border: 1px solid #292b2c;
  height: 32px;
  line-height: 31px;
  padding: 0 10px;
  border-radius: 4px;
  cursor: pointer;
  white-space: pre;
}

.flow-form .el-input,
.flow-form .el-select {
  width: 100% !important;
}
</style>
